import React from 'react';
import { BarChart3, TrendingUp, Trophy, MessageCircle } from 'lucide-react';

const benefits = [
  { icon: BarChart3, label: 'Sentiment Voting' },
  { icon: TrendingUp, label: 'Paper Portfolio' },
  { icon: Trophy, label: 'Stats & Streaks' },
  { icon: MessageCircle, label: 'Discussion' },
];

export const SignInBenefits: React.FC = () => (
  <div className="rush-benefits-bg rounded-xl bg-gradient-to-br from-[#f5f0e8] to-[#ebe5d8] dark:from-[#1e2028] dark:to-[#181a22] px-5 py-4 border border-[var(--auth-border-warm)]">
    <p className="font-serif text-base font-semibold text-foreground mb-3">
      Create a free account to unlock:
    </p>
    <div className="grid grid-cols-2 gap-x-4 gap-y-2.5">
      {benefits.map(({ icon: Icon, label }) => (
        <div key={label} className="flex items-center gap-2.5 text-sm text-[var(--auth-text-secondary)]">
          <div className="w-7 h-7 rounded-md flex items-center justify-center bg-[var(--auth-accent)]/10">
            <Icon className="h-3.5 w-3.5 shrink-0 text-[var(--auth-accent)]" />
          </div>
          <span>{label}</span>
        </div>
      ))}
    </div>
  </div>
);
